import { render } from "./LTL.vue?vue&type=template&id=5185a71d&scoped=true&ts=true"
import script from "./LTL.vue?vue&type=script&lang=ts"
export * from "./LTL.vue?vue&type=script&lang=ts"

import "./LTL.vue?vue&type=style&index=0&id=5185a71d&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5185a71d"]])

export default __exports__